import { useState } from "react";
import { Layers, Plus, X } from "lucide-react";

// CEN 2.0 FASE 3 PARTE A — catálogo de niveles físicos de la obra ({id, label}),
// elegido por ítem en el formulario de Pedido de Materiales y usado para filtrar
// el consumo por nivel (Parte B). Vive en el presupuesto, editable acá.
export function NivelesField({ form, setForm }) {
  const niveles = form.niveles || [];
  const [draft, setDraft] = useState("");

  const addNivel = () => {
    const label = draft.trim();
    if (!label) return;
    const id = label.toLowerCase().replace(/[^a-z0-9]+/g, "_").replace(/^_|_$/g, "") || `nivel_${niveles.length + 1}`;
    if (niveles.some(n => n.id === id)) { setDraft(""); return; }
    setForm(f => ({ ...f, niveles: [...(f.niveles || []), { id, label }] }));
    setDraft("");
  };

  const removeNivel = (id) => {
    setForm(f => ({ ...f, niveles: (f.niveles || []).filter(n => n.id !== id) }));
  };

  return (
    <div className="md:col-span-2" data-testid="niveles-field">
      <label className="block text-xs font-bold text-[#1A4B7A] mb-2 uppercase tracking-wide flex items-center gap-1.5">
        <Layers size={13} /> Niveles de la Obra <span className="font-normal text-gray-400 normal-case">(para el Pedido de Materiales)</span>
      </label>
      <div className="flex flex-wrap gap-2 mb-2">
        {niveles.length === 0 && <p className="text-xs text-gray-400 italic">Sin niveles definidos todavía.</p>}
        {niveles.map(n => (
          <span key={n.id} className="inline-flex items-center gap-1.5 bg-blue-50 text-blue-700 border border-blue-200 rounded-full pl-3 pr-1 py-1 text-xs font-semibold" data-testid={`nivel-chip-${n.id}`}>
            {n.label}
            <button type="button" onClick={() => removeNivel(n.id)} className="hover:bg-blue-200 rounded-full p-0.5" data-testid={`nivel-remove-${n.id}`}><X size={11} /></button>
          </span>
        ))}
      </div>
      <div className="flex gap-2">
        <input
          type="text" value={draft} onChange={e => setDraft(e.target.value)}
          onKeyDown={e => { if (e.key === "Enter") { e.preventDefault(); addNivel(); } }}
          placeholder="ej: Planta Baja, Planta Alta, Subsuelo..."
          className="flex-1 border border-gray-300 rounded-xl px-3 py-2 text-sm focus:ring-2 focus:ring-[#2E6DA4]/30"
          data-testid="nivel-draft-input"
        />
        <button type="button" onClick={addNivel} className="flex items-center gap-1 bg-[#2E6DA4] hover:bg-[#25588a] text-white rounded-xl px-3 py-2 text-xs font-semibold" data-testid="nivel-add-btn">
          <Plus size={13} /> Agregar
        </button>
      </div>
    </div>
  );
}
